<template>
  <div>
    <ChatListHeader @closeChat="closeChat" />
    <div style="height: 76vh; overflow-y: scroll;" v-loading="loading">
      <ChatListItem :count="systemMessageUnreadCount > 0 ? systemMessageUnreadCount : null" :name="$t('chat.system')" :id="'SYSTEM'" @openChat="openChat" />

      <div v-for="(item, index) in chatMsgList" :key="index">
        <ChatListItem :count="chatCount[item.number]" :name="item.name" :last-msg="getLastChat(item.messages)"
          :id="item.number" @openChat="openChat" />
      </div>
    </div>
  </div>
</template>

<script>
import ChatListHeader from './components/chatListHeader.vue';
import ChatListItem from './components/chatListItem.vue';
import eventBus from '../../../assets/js/eventBus';
export default {
  name: "ChatList",
  components: {
    ChatListHeader,
    ChatListItem
  },
  data() {
    return {
      logo: "",
      chatList: [],
      chatMsgList: [],
      systemMessageUnreadCount: parseInt(localStorage.getItem('systemUnread')),
      chatCount: {},
      chatLastMsgIds: new Map(),
      loading: false,
      lastDisplayMsgs: {}
    }
  },
  created() {
    eventBus.$on("onChatReceived", (data) => {
      if (localStorage.getItem("chatPage") == 1) {
        if (data.sender == 'SYSTEM') {
          const updatedCount = parseInt(this.systemMessageUnreadCount) + 1;
          this.systemMessageUnreadCount = updatedCount;
          localStorage.setItem('systemUnread', updatedCount);
          eventBus.$emit('updateTotalCount');
        } else {
          this.getAgentList(false)
        }
      }
    })

    // Msg deleted
    eventBus.$on("msgDeleted", (data) => {
      if (localStorage.getItem("chatPage") == 1) {
        this.chatLastMsgIds.forEach((values, key) => {
          if (values && values.some(item => item == data)) {
            let curr = this.chatCount[key]

            let counts = Object.assign({}, this.chatCount)
            counts[key] = curr - 1;
            this.chatCount = counts;
          }
        })
      }
    })
  },
  methods: {
    openChat(id) {
      if (id == "SYSTEM") {
        localStorage.setItem("systemUnread", 0)
        this.changeSystemReadStatus()
      }
      localStorage.setItem("chatAgentId", id)
      this.$emit("openChat");
    },
    getLogo() {
      let that = this;
      that
        .$http({
          url: "/app/Home/logo",
          method: "post",
          data: {
            logo_name: "login_register_logo"
          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.logo = res.data.data.login_register_logo
            localStorage.setItem("chatLogo", that.logo);
          }
        });
    },
    closeChat() {
      this.$emit("closeChat");
    },
    getAgentList(isShowLoading) {
      if (isShowLoading) {
        this.loading = true;
      }

      let that = this;
      that
        .$http({
          url: "/app/Chat/agentList",
          method: "post",
          data: {},
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.chatList = res.data.data;
            that.chatList.forEach(element => {
              element.messages = [];
            })

            let agentList = JSON.parse(localStorage.getItem("agent_list"));
            let isSameAsCurrent = true;

            if (agentList && agentList.length > 0) {
              that.chatList.forEach(item => {
                const availableInStore = agentList.find(agent => agent.number === item.number);
                //User not available in local storage
                if (!availableInStore) {
                  isSameAsCurrent = false;
                }
              })
            } else if (!agentList || !agentList.length) {
              isSameAsCurrent = false;
            }

            if (!isSameAsCurrent) {
              localStorage.setItem("agent_list", JSON.stringify(res.data.data))

              if (that.chatList.length > 0) {
                that.getChatHistory(isShowLoading);
              }
            } else {
              that.orderAgentList()
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
            that.loading = false;
          }
        }).catch(() => {
          that.loading = false;
        })
    },
    setMessageList(messageItem) {
      let agentList = JSON.parse(localStorage.getItem('agent_list'));

      // Handle delete messages
      if (messageItem.type == -100) {
        let deleted = localStorage.getItem("deletedMsgs") ? JSON.parse(localStorage.getItem("deletedMsgs")) : []
        deleted.push(messageItem.message);
        localStorage.setItem("deletedMsgs", JSON.stringify(deleted));
        eventBus.$emit("msgDeleted", messageItem.message);
      }

      agentList.forEach(element => {
        if (element.number == messageItem.receiver || element.number == messageItem.sender) {
          element.messages.push(messageItem);
          element.last_msg = messageItem;
        }
        // Sort the messages by time
				element.messages.sort((a, b) => a.time - b.time);
      });
      localStorage.setItem('agent_list', JSON.stringify(agentList));
    },
    getChatHistory() {
      let that = this;
      that
        .$http({
          url: "/app/Chat/getHistory",
          method: "post",
          data: {
            user_id: localStorage.getItem("uid")
          },
          chatUrl: true,
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let msgList = res.data.data;
            msgList = msgList.filter(element => element.is_read == 1);

            msgList.sort((a, b) => b.timestamp - a.timestamp);

            msgList.forEach(element => {
              that.setMessageList(element);
            });

            that.orderAgentList()

            // Set the count
						const messageAgents = JSON.parse(localStorage.getItem('agent_list'));
            const uid = localStorage.getItem('uid');
						messageAgents.forEach(element => {
              const unreadMsgs = element.messages.filter(item => item.is_read != 1 && item.receiver == uid);
              element.count = unreadMsgs.length;
            });
            localStorage.setItem("agent_list", JSON.stringify(messageAgents));
						eventBus.$emit("updateTotalCount");

            const msgListReversed = msgList.reverse();
            localStorage.setItem('last_msg_id', msgListReversed[0].order_id);
            localStorage.setItem('last_msg_receiver', msgListReversed[0].receiver);
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    orderAgentList() {
      let context = this;
      let existingAgents = JSON.parse(localStorage.getItem('agent_list'))

      //Remove agents that were disabled by the admin
      if (context.chatList.length > 0) {
        existingAgents.forEach(item => {
          const availableInAPIList = context.chatList.find(agent => agent.number ===
            item.number);
          if (!availableInAPIList) {
            const removalIndex = existingAgents.findIndex((element) => element.number == item.number);
            existingAgents.splice(removalIndex, 1)
          }
        })
      }

      localStorage.setItem('agent_list', JSON.stringify(existingAgents));

      // Order the agent list according to newest msg
      let agentList = existingAgents

      let orderedAgents = []
      if (agentList.length) {
        orderedAgents = agentList.sort((a, b) => {
          const a_lastMsg = this.getLastMsg(a.messages);
          const b_lastMsg = this.getLastMsg(b.messages);

          if (b_lastMsg && a_lastMsg) {
            return b_lastMsg.time - a_lastMsg.time;
          } else if (!b_lastMsg && !a_lastMsg) {
            return 0;
          } else if (b_lastMsg && !a_lastMsg) {
            return 1;
          } else if (a_lastMsg && !b_lastMsg) {
            return -1;
          }
        })
      }


      localStorage.setItem('agent_list', JSON.stringify(orderedAgents));
      this.chatMsgList = JSON.parse(localStorage.getItem('agent_list'))
      this.loading = false;

      this.setMaps()
    },
    getLastMsg(msgList) {
      const chatReversed = msgList.slice().reverse()
      const lastChat = chatReversed.find(msg => {
        var chatDeleted = localStorage.getItem("deletedMsgs") ? JSON.parse(localStorage.getItem("deletedMsgs")) : null;
        if (chatDeleted) {
          const deleted = chatDeleted.findIndex(item => item == msg.order_id)
          return msg.status != 0 && deleted == -1 && msg.type != -100
        } else {
          return msg.status != 0 && msg.type != -100
        }
      })
      return lastChat;
    },
    setMaps() {
      this.chatMsgList.forEach(item => {
        this.chatCount[item.number] = item.count
        this.chatLastMsgIds.set(item.number, item.unreadMsgIds)
        this.lastDisplayMsgs[item.number] = this.getLastChat(item.messages)
      })
    },
    getLastChat(chats) {
      if (chats.length) {
        // Get the last msg which is not deleted
        const chatReversed = chats.slice().reverse()
        const lastChat = chatReversed.find(msg => {
          var chatDeleted = localStorage.getItem("deletedMsgs") ? JSON.parse(localStorage.getItem("deletedMsgs")) : null;
          if (chatDeleted) {
            const deleted = chatDeleted.findIndex(item => item == msg.order_id)
            return msg.status != 0 && deleted == -1 && msg.type != -100
          } else {
            return msg.status != 0 && msg.type != -100
          }
        })

        if (lastChat) {
          switch (lastChat.type) {
            case 0:
              return lastChat.message;
            case 1:
              return this.$t('field.lastMsgImage')
            case 8:
              return this.$t('field.lastMsgVideo')
            case 3:
              return this.$t('field.lastMsgFile')
            default:
              return lastChat.message;
          }
        }
      }
      return ''
    },
    changeSystemReadStatus(){
      let availableSystemMessages = JSON.parse(localStorage.getItem('systemMessages'))
      if(availableSystemMessages.length > 0){
      availableSystemMessages.forEach((item,index)=>{
        if(!item.readStatus){
          availableSystemMessages[index].readStatus = true
          localStorage.setItem('systemMessages',JSON.stringify(availableSystemMessages))
        }
      })
    }
    }
  },
  mounted() {
    this.getAgentList(true)
    this.getLogo();
  }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/module/chat/chatList.vue